// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"eb0bed12","226":"a567bb5f","257":"d4238664","488":"1863509d","704":"b867d62c","913":"3061fa11","945":"3eb52b06","977":"d6dc10fe"}[chunkId] + ".chunk.js";
};